import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Modal } from "antd";
import CustomerForm, {} from "./CustomerForm";
const CustomerUpdateModal = ({ tenantId, customer, open, onCancel, onSave }) => {
    const customerFormRef = useRef(null);
    const editMode = !!(customer && customer.id);
    return (_jsx(Modal, { title: editMode ? "Edit customer" : "Create new customer", open: open, onOk: () => customerFormRef.current?.submit(), onCancel: onCancel, destroyOnHidden: true, children: _jsx(CustomerForm, { ref: customerFormRef, tenantId: tenantId, onSave: onSave, customer: customer }) }));
};
export default CustomerUpdateModal;
